<script>
   import { onMount } from "svelte";
   import { productsRecomendations } from "$lib/models/search/searchRecomendations";
   import TinyCardProducts from "$lib/components/global/TinyCardProducts.svelte";
 
   /**
    * @param {number}number
    * @param {number} maxNumber
    * */
   const getUniquePositions = (number, maxNumber) => {
     const occupiedPositions = new Set();
     const positions = [];
     while (positions.length < number) {
       const x = Math.floor(Math.random() * maxNumber);
       if (!occupiedPositions.has(x)) {
         occupiedPositions.add(x);
         positions.push(x);
       }
     }
     return positions;
   };
   /**@type {import ("$lib/types").PublicProduct[]}*/
   let recomendedProducts;
   const getProducts = async () => {
     let randomArray = getUniquePositions(10, productsRecomendations.length - 1);
     /**@type {string | string[]}*/
     let skus = productsRecomendations.filter((item, index) =>
       randomArray.includes(index)
     );
     skus = skus.join("&s=");
     try {
       const fetchProducts = await fetch(`/search/by_sku?s=${skus}`);
       recomendedProducts = await fetchProducts.json();
     } catch (error) {
       console.log(error);
     }
   };
 
   onMount(() => {
     getProducts();
   });
 </script>
 
 <div class="container">
   <h3>Recomended Products</h3>
   {#if recomendedProducts && recomendedProducts?.length > 0}
     <div class="products">
       {#each recomendedProducts as product}
         <li>
           <TinyCardProducts {product} />
         </li>
       {/each}
     </div>
   {/if}
 </div>
 
 <style>
   .container {
     width: 100%;
     height: 80%;
     overflow: hidden;
   }
   .container h3 {
     font-size: 1rem;
     font-family: "gotham-medium";
     padding: 0 20px;
     margin: 20px 0;
   }
   .products {
     list-style: none;
     display: grid;
     grid-template-columns: repeat(2, 1fr);
     overflow-y: auto;
     margin: 0 auto;
     width: 98%;
     height: 100%;
     gap: 5px;
     scrollbar-width: none;
     padding-bottom: 250px;
     scroll-snap-type: x mandatory;
    }
   .products::-webkit-scrollbar {
     width: 0;
   }
   .products li {
     width: 100%;
     height: 100%;
     scroll-snap-align: start;
   }
   @media (min-width: 768px) {
     .container {
       height: 100%;
       max-width: 1420px;
    }
     .products {
       grid-template-columns: repeat(10, 280px);
       overflow-y: hidden;
       overflow-x: scroll;
       scrollbar-width: thin;
       height: fit-content;
       gap: 30px;
       padding: 20px;
     }
   }
 </style>